<div class="card-footer" [class.card-footer--margin-top]="marginTop">
    <ng-content></ng-content>
</div>
